module.exports = __webpack_public_path__ + "img/western_union_icon.6881122a.png";